import React from 'react';
import { FormattedMessage } from 'react-intl';
import configs from 'config';

import theme from './Footer.scss';

const Footer = () => {
  return (
    <div className={ theme.root }>
      <div className={ theme.text }>
        <FormattedMessage
          id="General.Footer.Copyright"
          defaultMessage="** Company Footer"
        />
        &nbsp; Ver. { configs.release_version }
      </div>
    </div>
  );
};

export default Footer;
